import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { SessionsSessionViewDialogComponent } from '../../../sessions/components/session-view-dialog/session-view-dialog';
import { TimeslotRow } from '../../providers/timeslots-provider';
import { MatDialog } from '@angular/material/dialog';
import { Organization } from "../../../common/models/organization";
import { Athlete } from "../../../common/models/athlete";
import { SecondsToDHMPipe } from "../../../common/pipes/seconds-to-DHM-pipe";
import { DefaultPipe } from "../../../common/pipes/default";
import { NgIf } from "@angular/common";
import { LangsProvider } from "../../../common/providers/langs-provider";
import { CdkDragHandle } from "@angular/cdk/drag-drop";
import { MatIcon } from "@angular/material/icon";
import { User } from "../../../common/models/user";

@Component({
  selector: 'agendas-calendar-event',
  providers: [],
  styleUrls: ['./calendar-event.scss'],
  templateUrl: './calendar-event.html',
  standalone: true,
  imports: [
    SecondsToDHMPipe,
    DefaultPipe,
    NgIf,
    CdkDragHandle,
    MatIcon
  ],
})
export class AgendasCalendarEventComponent implements AfterViewInit {
    @Input() public set slot(slot: TimeslotRow) {
        this._slot = slot;
        this.computeHeight();
    }
    public get slot() {
        return this._slot;
    }
    public readonly BORDER_WIDTH: number = 1;
    @Input() public organization: Organization  | null = null;
    @Input() public athleteUser: User | null = null;
    @Input() public timeSegments = 2;
    @Input() public lineHeight = 48;
    @Input() public currentUrl: string = '';
    @Input() public isEditable = false;
    @Output() onRefresh = new EventEmitter<void>();

  public slotHeight = 0;
    private _slot: TimeslotRow = {} as TimeslotRow;
    constructor(
        private _dialog: MatDialog,
        private cdr: ChangeDetectorRef,
        private langsProvider: LangsProvider,
    ) {
    }

    public ngAfterViewInit() {
      if (this._slot.session) {
        if (this._slot.session.name == null) {
          const langId = this.langsProvider.getBestLangId();
          // this._slot.session.name = this._slot.session.name || this._slot.session.translations[langId]?.name || '';
        }
      }
    }

    public onSeeSessionClicked(): void {
      const dialogRef: any = this._dialog.open(SessionsSessionViewDialogComponent, {
        data: {
          sessionId: this._slot.session!.id,
          sessionRow: this._slot.session,
          organization: this.organization,
          timeslot: this.slot.timeslot,
          athleteUser: this.athleteUser,
          currentUrl: this.currentUrl,
          isEditable: this.isEditable,
          // va savoir pourquoi c'est géré comme ça mais si libraryId n'est pas existant alors c'est que c'est un exit safe, pas de modif en attente
          isExitSafe: this._slot.session?.libraryId == undefined || this._slot.session?.libraryId == 0,
        }
      }).afterClosed().subscribe((refresh?: boolean) => {
        if (refresh) {
          // force refresh calendar
          this.onRefresh.emit();

        }
      });
    }

    public onMoreSectionClicked(event: any): void {
        event.stopPropagation();
    }

    private computeHeight() {
        if (!this._slot) {
            this.slotHeight = 0;
            return;
        }

        // on fait en sorte que l'event occupe des segments entiers
        // on arrondit donc vers le haut le nombre de segment nécessaire à l'affichage de l'event
        const segmentHeight: number = this.lineHeight / this.timeSegments;

        this.slotHeight = (Math.ceil(this._slot.session!.totalTime! / ((60 / this.timeSegments) * 60)) * segmentHeight) - (2 * this.BORDER_WIDTH);
    }
}
